import { createWebHistory, createRouter } from "vue-router";
import Home from "@/views/Home.vue";
import About from "@/views/About.vue";
import Dorm from "@/views/Dorm.vue";
import AddReview from "@/views/AddReview.vue";

const routes = [
  {
    path: "/home",
    name: "Home2",
    component: Home,
    meta: {
      title: 'UMN Housing Reviews | Compare Dorms & Apartments | Gopher Housing',
      description: 'Find the perfect UMN housing with authentic reviews. Compare University of Minnesota dorms and apartments with real student ratings and experiences.'
    }
  },
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: 'UMN Housing Reviews | Compare Dorms & Apartments | Gopher Housing',
      description: 'Find the perfect UMN housing with authentic reviews. Compare University of Minnesota dorms and apartments with real student ratings and experiences.'
    }
  },
  {
    path: "/about",
    name: 'About',
    component: About,
    meta: {
      title: 'About Gopher Housing | UMN Housing Review Platform',
      description: 'Learn about Gopher Housing, your trusted platform for University of Minnesota housing reviews. Discover our mission to help students make informed housing decisions.'
    }
  },
  {
    path: "/:dormName",
    name: 'dorm-view',
    component: Dorm,
    meta: {
      title: (route) => `${route.params.dormName} Reviews & Ratings | UMN Housing | Gopher Housing`,
      description: (route) => `Read authentic student reviews of ${route.params.dormName} at University of Minnesota. View ratings, amenities, photos, and make informed housing decisions.`
    }
  },
  {
    path: "/:dormName/add-review",
    name: 'add-review',
    component: AddReview,
    meta: {
      title: (route) => `Review ${route.params.dormName} | UMN Housing Reviews`,
      description: (route) => `Share your experience living at ${route.params.dormName}. Help other University of Minnesota students make informed housing decisions.`
    }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation guard to update meta tags
router.beforeEach((to, from, next) => {
  // Update meta title
  const title = typeof to.meta.title === 'function' ? to.meta.title(to) : to.meta.title;
  document.title = title || 'Gopher Housing';

  // Update meta description
  const description = typeof to.meta.description === 'function' ? to.meta.description(to) : to.meta.description;
  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute('content', description || '');
  }

  // Update OG tags
  const ogTitle = document.querySelector('meta[property="og:title"]');
  const ogDescription = document.querySelector('meta[property="og:description"]');
  if (ogTitle) ogTitle.setAttribute('content', title || '');
  if (ogDescription) ogDescription.setAttribute('content', description || '');

  // Update canonical URL
  const canonical = document.querySelector('link[rel="canonical"]');
  if (canonical) {
    canonical.setAttribute('href', `https://www.gopherhousing.com${to.path}`);
  }

  next();
});

export default router;